<template>
    <card>
        <template slot="header">
            <h2 class="card-title">{{ title }}</h2>
        </template>
        <div class="row">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-8 d-flex flex-column justify-content-center">
                        <h3>{{ $t('dashboard.general__global') }}</h3>
                        <table class="table chart-legend-table">
                            <tbody>
                                <tr v-for="(item, index) in data.global" :key="index">
                                    <td><strong>{{ $t(item.title) }}</strong></td>
                                    <td class="text-right">{{ item.count }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-4">
                        <pie-chart :chart-id="'pie-chart-' + type" :chart-data="chartData" :extra-options="chartOptions"></pie-chart>
                    </div>
                </div>
            </div>
        </div>

        <hr class="mt-5 mb-5" />

        <!-- <hr class="mt-5 mb-5" /> -->

        <div class="row mt-5">
            <div class="col-8 d-flex flex-column justify-content-center">
                <h3>{{ $t('dashboard.general__regional') }}</h3>
                <table class="table chart-legend-table">
                    <thead>
                        <th>&nbsp;</th>
                        <td class="text-center" v-for="(region, id) in data.regional" :key="id"><b>{{ region.name }}</b></td>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in data.global" :key="index">
                            <td>{{ $t(item.title) }}</td>
                            <td class="text-center" v-for="(region, id) in data.regional" :key="id">{{ region[index] }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-4">
                <bar-chart :chart-id="'bar-chart-' + type + '-' + grantId" :chart-data="regionalChartData" :extra-options="barChartOptions"></bar-chart>
            </div>
        </div>

        <div class="row mt-5">
            <div class="col-12">
                <base-button @click="exportExcell()" type="default" size="lg" class="btn-fill text-right">
                    Export
                </base-button>
                <base-button @click="viewDistributionByCountry = true" type="default" size="lg" class="btn-fill pull-right">
                    View Distribution by Country
                </base-button>
            </div>
        </div>

        <popup-by-country v-if="byCountryData" :visible.sync="viewDistributionByCountry" :data="byCountryData" :data-key="dataKey"></popup-by-country>
    </card>
</template>
<script>
import {UserRoles} from "@/services";
import PieChart from "src/components/Charts/PieChart.js";
import BarChart from "src/components/Charts/BarChart.js";
import { lab } from 'd3';

import PopupByCountry from '../Popups/PopupByCountry';

export default
{
    name: "applications-by-card",
    components:
    {
        PieChart,
        BarChart,
        PopupByCountry
    },
    props:
    {
        data:
        {
            type: Object,
            default: () => ({
                global: {},
                regional: []
            }),
        },
        byCountryData: Object,
        dataKey: String,
        items: Array,
        title: String,
        type: String,
        filters: Object,
        grantId: Number
    },
    data()
    {
        return {
            loggedUser: {},
            viewDistributionByCountry: false,
            chartOptions:
            {
                tooltips:
                {
                    // enabled: true,
                    mode: 'label',
                    // callbacks:
                    // {
                    //     label: (item, data) =>
                    //     {
                    //         console.log(item, data);

                    //         return [];
                    //     }
                    // }
                },
                legend:
                {
                    display: false
                },
                responsive: true
            },
            barChartOptions:
            {
                tooltips:
                {
                    // enabled: true,
                    mode: 'label',
                    // callbacks:
                    // {
                    //     label: (item, data) =>
                    //     {
                    //         console.log(item, data);

                    //         return [];
                    //     }
                    // }
                },
                legend:
                {
                    display: false
                },
                responsive: true,
                scales: {
                    yAxes: [{
                        ticks: {
                            stepSize: 1
                        }
                    }]
                }
            },
        };
    },
    computed:
    {
        chartData: function ()
        {
            const vm = this;
            let labels = [];
            let data = [];

            if (vm.data.global)
            {
                for (let index in vm.data.global)
                {
                    const item = vm.data.global[index];

                    let label = vm.$t(item.title);

                    if (label.split(' ').length > 7)
                    {
                        label = label.split(' ').splice(0, 7).join(' ') + '...';
                    }

                    labels.push(label);
                    data.push(item.count);
                }
            }

            return {
                datasets:
                [
                    {
                        backgroundColor: ['#ff6384', '#ffcd56', '#36a2eb', '#8ceb36', '#6393ff', '#9863ff', '#4E0013', '#74132C', '#FF9837', '#267257', '#0E553C', '#b0b6f2', '#c8bef3', '#dbc7f3', '#ebd2f4', '#d8eb67', '#FA6ECA', '#FFFF05', '#000000', '#21BFBF', '#BF2604', '#593F36', '#6B1C8C', '#A64484'],
                        data: data
                    }
                ],
                labels: labels
            };
        },
        regionalChartData: function (status)
        {
            const vm = this;
            let labels = [];
            let datasets = [];
            const colors = ['#ff6384', '#ffcd56', '#36a2eb', '#8ceb36', '#6393ff', '#9863ff', '#4E0013', '#74132C', '#FF9837', '#267257', '#0E553C', '#b0b6f2', '#c8bef3', '#dbc7f3', '#ebd2f4', '#d8eb67', '#FA6ECA', '#FFFF05', '#000000', '#21BFBF', '#BF2604', '#593F36', '#6B1C8C', '#A64484'];

            if (vm.data.regional)
            {

                let data = Array(vm.data.global.length).fill(0).map(() => []);

                for (let key in vm.data.regional)
                {
                    const region = vm.data.regional[key];

                    labels.push(region.name);
                }

                for (let key in vm.data.regional)
                {
                    const region = vm.data.regional[key];

                    for (let i in region)
                    {
                        let item = region[i];

                        if (i !== 'name')
                        {
                            data[i].push(item);
                        }
                    }

                }

                datasets = data.map((item, index) =>
                {
                    let label = vm.$t((vm.data.global[index] || {}).title);

                    if (label.split(' ').length > 7)
                    {
                        label = label.split(' ').splice(0, 7).join(' ') + '...';
                    }

                    return {
                        label: label,
                        backgroundColor: colors[index],
                        data: item
                    };
                });
            }

            return {
                datasets: datasets,
                labels: labels
            };
        }
    },
    beforeMount()
    {
        this.loggedUser = this.$store.getters['Auth/loggedUser'];
    },
    mounted()
    {
        const vm = this;

        // console.log(vm.data.regional.map((item) => item.name));

        // vm.statusChartData

        // [vm.data.global.drafts, vm.data.global.submitted];
        // [vm.data.global.awarded, vm.data.global.rejected]
    },
    methods:
    {
        exportExcell()
        {
            const vm = this;
            let url = process.env.VUE_APP_ROOT_API + '/dashboard/export?';
            let attrs = [
                'by=' + vm.type,
                'grant_id=' + vm.grantId,
            ];

            if (vm.filters.status)
            {
                attrs.push('status=' + vm.filters.status);
            }

            if (vm.filters.final_status)
            {
                attrs.push('final_status=' + vm.filters.final_status);
            }

            if (vm.loggedUser && vm.loggedUser.role === UserRoles.REGIONAL_ADMIN)
            {
                attrs.push('regions=' + vm.loggedUser.regionIds.join(','));
            }

            url = url + attrs.join('&');

            window.location = url;
        }
    }
};
</script>
<style>
    .bpf-chart-holder
    {
        display: flex;
        justify-content: center;
    }

    #pie-chart
    {
        /* width: 80% !important;
        height: auto !important; */
        margin: auto;
    }

    #bar-chart
    {
        /* height: 300px !important; */
    }
</style>
